import React from 'react';
import PropTypes from 'prop-types';
import { observer, PropTypes as mobxPropTypes } from 'mobx-react';
import { Select } from '@elevio/elevio-styles/dist/components/hq';

const ObservableSelect = (
  { fieldId, options, response, mode, ...rest },
  { domContainer }
) => (
  <Select
    key={`Select_${fieldId}`}
    id={`${fieldId}`}
    mode={mode}
    {...rest}
    value={response.slice() || []}
    getPopupContainer={domContainer}
    allowClear
  >
    {options.map(o => (
      <Select.Option key={o.key} disabled={o.disabled} value={o.value}>
        {o.value}
      </Select.Option>
    ))}
  </Select>
);

ObservableSelect.propTypes = {
  fieldId: PropTypes.number.isRequired,
  options: PropTypes.oneOfType([mobxPropTypes.observableArray, PropTypes.array]) // eslint-disable-line react/no-typos
    .isRequired,
  mode: PropTypes.string.isRequired,
  response: PropTypes.oneOfType([
    mobxPropTypes.observableArray, // eslint-disable-line react/no-typos
    PropTypes.string,
    PropTypes.array,
    PropTypes.number,
    PropTypes.shape({
      file: PropTypes.shape({
        name: PropTypes.string,
      }),
      fileList: mobxPropTypes.observableArray, // eslint-disable-line react/no-typos
    }),
  ]),
};

ObservableSelect.defaultProps = {
  response: '',
};

ObservableSelect.contextTypes = {
  domContainer: PropTypes.func.isRequired,
};

export default observer(ObservableSelect);



// WEBPACK FOOTER //
// ./src/components/select/index.js